import toast from 'react-hot-toast';

/**
 * Toast Notification Utilities
 * Provides consistent, styled toast notifications throughout the app
 */

// Success toast - Green
export const showSuccess = (message) => {
    return toast.success(message, {
        duration: 3500,
        position: 'top-right',
        style: {
            background: '#10b981',
            color: '#fff',
            fontWeight: '600',
            borderRadius: '12px',
            padding: '16px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
        iconTheme: {
            primary: '#fff',
            secondary: '#10b981',
        },
    });
};

// Error toast - Red
export const showError = (message) => {
    return toast.error(message, {
        duration: 4000,
        position: 'top-right',
        style: {
            background: '#ef4444',
            color: '#fff',
            fontWeight: '600',
            borderRadius: '12px',
            padding: '16px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
        iconTheme: {
            primary: '#fff',
            secondary: '#ef4444',
        },
    });
};

// Warning toast - Yellow/Orange
export const showWarning = (message) => {
    return toast(message, {
        duration: 3500,
        position: 'top-right',
        icon: '⚠️',
        style: {
            background: '#f59e0b',
            color: '#fff',
            fontWeight: '600',
            borderRadius: '12px',
            padding: '16px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
    });
};

// Info toast - Blue
export const showInfo = (message) => {
    return toast(message, {
        duration: 3000,
        position: 'top-right',
        icon: 'ℹ️',
        style: {
            background: '#3b82f6',
            color: '#fff',
            fontWeight: '600',
            borderRadius: '12px',
            padding: '16px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
    });
};

// Loading toast - for async operations
export const showLoading = (message) => {
    return toast.loading(message, {
        position: 'top-right',
        style: {
            background: '#6366f1',
            color: '#fff',
            fontWeight: '600',
            borderRadius: '12px',
            padding: '16px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
    });
};

// Promise toast - automatically handles loading/success/error states
export const showPromise = (promise, messages) => {
    return toast.promise(
        promise,
        {
            loading: messages.loading || 'Loading...',
            success: messages.success || 'Success!',
            error: messages.error || 'Error occurred',
        },
        {
            position: 'top-right',
            style: {
                fontWeight: '600',
                borderRadius: '12px',
                padding: '16px',
            },
        }
    );
};

export default {
    success: showSuccess,
    error: showError,
    warning: showWarning,
    info: showInfo,
    loading: showLoading,
    promise: showPromise,
};
